import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=3cd08094&scoped=true&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"
import style0 from "./Modal.vue?vue&type=style&index=0&id=3cd08094&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../buyers/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd08094",
  null
  
)

export default component.exports